export default {
  filterData : {
    Products: {
      label: 'Produtos',
      allFilterLabel: "Todos os produtos",
      items: [
        { name: "Citrix ADC", id: "citrix_adc" },
        { name: "Citrix Analytics for Performance", id: "citrix_analytics_for_performance" },
        { name: "Citrix Analytics for Security", id: "citrix_analytics_for_security" },     
        { name: "Citrix App Delivery and Security Service", id:"citrix_app_delivery_and_security_service"},
        { name: "Citrix Application Delivery Management", id: "citrix_application_delivery_management" },
        { name: "Citrix Content Collaboration", id: "citrix_content_collaboration" },
        { name: "Citrix DaaS (formerly Citrix Virtual Apps and Desktops service)", id: "citrix_virtual_apps_and_desktops" },
        {
          name: "Citrix DaaS Standard for Azure",
          id: "citrix_virtual_apps_and_desktops_standard_for_azure"
        },
        {
          name: "Citrix DaaS Standard for Google Cloud",
          id: "citrix_daas_standard_for_google_cloud",
        },
        { name: "Citrix Endpoint Management", id: "citrix_endpoint_management" },
        { name: "Citrix Gateway", id: "citrix_gateway" },
        { name: "Citrix SD-WAN", id: "citrix_sd_wan" },
        { name: "Citrix Secure Internet Access", id: "citrix_secure_internet_access" },
        { name: "Citrix Secure Private Access", id: "citrix_secure_private_access" },
        { name: "Citrix Virtual Apps and Desktops", id: "citrix_virtual_apps_desktops" },
        { name: "Citrix Web App and API Protection", id: "citrix_web_app_and_api_protection" },
        { name: "Citrix Workspace", id: "citrix_workspace" },
      ],
    },
    Topics: {
      label: "Tópicos",
      allFilterLabel: "Todos os tópicos",
      items: [
        { name: "Gerenciamento de acesso", id: "Access management" },
        { name: "Análises e monitoramento", id: "Analytics and monitoring" },
        { name: "Segurança e entrega de aplicativos", id: "Application delivery and security" },
        { name: "Citrix e Google", id: "Citrix and Google" },
        { name: "Citrix e Microsoft", id: "Citrix and Microsoft" },
        { name: "Migração para a nuvem", id: "Cloud migration" },
        { name: "Compare", id: "Compare" },
        { name: "Content collaboration", id: "Content collaboration" },
        { name: "Espaços de trabalho digital", id: "Digital workspaces" },
        { name: "Experiência do funcionário", id: "Employee experience" },
        { name: "Nuvem híbrida", id: "Hybrid cloud" },
        { name: "Trabalho híbrido", id: "Hybrid work" },
        { name: "Gerenciar e otimizar", id: "Manage and optimize" },
        { name: "Microsserviços e operações de desenvolvimento", id: "Microservices and devOps" },
        { name: "Integração e adoção", id: "Onboarding and adoption" },
        { name: "Integrações de parceiros", id: "Partner integrations" },
        { name: "Visão geral do produto", id: "Product overview" },
        { name: "Segurança e conformidade", id: "Security and compliance" },
        { name: "Pequenas empresas", id: "Small business" },
        { name: "Especificações", id: "Specifications" },
        { name: "Sustentabilidade", id: "Sustainability" },
        { name: "Gerenciamento unificado de endpoints", id: "Unified endpoint management" },
        { name: "VDI e DaaS", id: "VDI and DaaS" },
      ],
    }, 
    Type: {
      label: 'Tipo',
      allFilterLabel: "Todos os tipos",
      items: [
        { name: "Relatório de analista", id: "Analyst report" },
        { name: "Ferramenta de avaliação", id: "Assessment tool" },
        { name: "Histórias de clientes", id: "Customer story" },
        { name: "Folha de dados", id: "Data sheet" },
        { name: "Demonstração", id: "Demo" },
        { name: "E-book", id: "eBook" },
        { name: "Guia", id: "Guide" },
        { name: "Infográfico", id: "Infographic" },
        { name: "Tour interativo", id: "Interactive tour" },
        { name: "Podcast", id: "Podcast" },
        { name: "Kit de recursos", id: "Resource kit" },
        { name: "Resumo da solução", id: "Solution brief" },
        { name: "Resumo técnico", id: "Technical brief" },
        { name: "Vídeo", id: "Video" },
        { name: "Webinar", id: "Webinar" },
        { name: "Artigo técnico", id: "White paper" },
      ],
    },
    Industry: {
      label: "Setor",
      allFilterLabel: "Todos os setores",
      items: [
        { name: "Educação", id: "education" },
        { name: "Serviço financeiro", id: "financial_service" },
        { name: "Governo", id: "government" },
        { name: "Saúde", id: "healthcare" },
        { name: "Manufatura", id: "manufacturing" },
        { name: "Varejo", id: "retail" }
      ],
    }
  },
    searchPlaceholder: "Pesquisar na biblioteca",
    titles : {
      label1: "Tendências atuais",
      label2: "Recursos mais novos",
      label3: "Visualizado recentemente",
      label4: "Recursos recomendados"
    },
    showMoreLabel: "Exibir mais",
    clearAllSelected: "Limpar todos os itens selecionados",
    searchResults: "Resultados da pesquisa por",
    clearAllFilters: "Limpar todos os filtros",
    noResultsFound: "Nenhum ativo cumpre os seus critérios selecionados",
    resetView: "Redefinir exibição",
    filterLabel: "Filtrar",
    filteredRes: "Resultados filtrados",
    filterRes: "Filtrar seus resultados",
    clearAllCta: "Limpar tudo",
    applyCta: "Inscreva-se",
    view: "Exibir",
    includeEnglishRes: "Incluir recursos em inglês"
  };
  